import User from 'js/core_post_webpack/models/user';
import fullstoryHeaderCode from './fullstory_header';

// Set in fullstory_header
declare global {
  interface Window {
    FS:
      | {
          identify: (uid: string, extra: Record<string, unknown>) => unknown;
          event: (event: string, details?: Record<string, unknown>) => unknown;
          shutdown: () => unknown;
          restart: () => unknown;
          setVars: SetPageVars;
        }
      | undefined;
  }
}

export type UserLike = {
  id: number;
  display_name?: string | null;
  email: string;
  premium: boolean;
};

export function initializeFullstory(user?: UserLike, restart = false) {
  if (restart) {
    if (!window.FS) return;
    window?.FS?.restart();
  } else {
    if (window.FS) return;
    fullstoryHeaderCode();
  }

  if (user) {
    const userVars = {
      id_int: user.id,
      displayName: user.display_name,
      email: user.email,
      premium_bool: user.premium,
    };

    window?.FS?.identify(user.id.toString(), userVars);
  }
  fsEvent('ServerHit', {
    controller_str: window.$controller_name,
    actionName_str: window.$action_name,
    hitId_int: window?.Aedu?.hit_data?.id,
  });

  if (window.$controller_name && window.$action_name) {
    window?.FS?.setVars('page', {
      pageName: `${window.$controller_name}/${window.$action_name}`,
      controller_str: window.$controller_name,
      actionName_str: window.$action_name,
      hitId_int: window?.Aedu?.hit_data?.id,
    });
  }
  return true;
}

export function initializeAndStopFullstory() {
  if (window.FS) return;

  fullstoryHeaderCode();
  // @ts-expect-error fullstoryHeaderCode() will have just set window.FS
  window?.FS?.shutdown();

  return true;
}

export function fsEvent(event: string, details?: Record<string, unknown>) {
  window.FS?.event(event, details);
}

// We set the `record_session` cookie on the backend to control which requests we wish to record for
// Note that it's lifecycle isn't quite the same as fullstory's, though hopefully it will be similar
export function startRecordingIfSamplingRequest(user?: UserLike) {
  if (getCookie('record_session') !== undefined) {
    initializeFullstory(user || User.current);
  } else if (window.Aedu?.activateFullstory) {
    initializeAndStopFullstory();
  }
}

function getCookie(key: string): string | undefined {
  return window.document.cookie
    .split('; ')
    .find((row) => row.startsWith(`${key}=`))
    ?.split('=')[1];
}
